var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShootPlayerRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 49"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 6",
    cx: 36.5,
    cy: 6,
    rx: 36.5,
    ry: 6,
    transform: "matrix(-1 0 0 1 72.9995 64.125)",
    fill: "url(#paint0_linear_68_186358)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M75.8602 7.8761C75.7248 8.75931 75.2553 9.53675 74.5373 10.0674L60.7047 20.6158C60.5786 22.4749 60.3633 30.3607 60.2409 35.5115C60.7715 36.3353 62.8293 39.2539 64.6643 41.8534C71.0768 50.9452 71.0787 51.0232 71.0972 51.5186V67.7558C71.1473 69.5574 69.6147 71.129 67.7407 71.194C67.7017 71.1958 67.6609 71.1958 67.6238 71.1958C65.8184 71.1958 64.3545 69.7875 64.2821 67.984L63.2393 52.3053L54.8433 41.9796C52.7225 43.8128 46.6997 49.2493 42.792 52.8007C41.6843 53.914 39.9309 54.1051 38.608 53.2516L26.6328 45.5347C25.0835 44.5346 24.6344 42.462 25.6345 40.9109C26.6272 39.369 28.6849 38.9181 30.2324 39.8941L39.7417 45.3176C43.3097 41.7829 48.4605 36.6266 49.5367 35.4168V25.4993L39.3576 34.4075C38.8659 34.8528 37.8268 35.2702 36.7673 35.2127C35.9008 35.1682 35.1568 34.8175 34.6206 34.1978C33.4034 32.795 33.4887 30.7299 34.8135 29.4979L49.9412 15.3815C50.1416 15.1941 50.4032 15.0902 50.6778 15.0902H50.6796C52.7244 15.092 55.6467 15.092 56.6413 15.092L70.5647 4.68655C71.2902 4.15218 72.1734 3.93509 73.0566 4.06683C73.9398 4.20042 74.7191 4.66985 75.2479 5.38978C75.7767 6.1097 75.9938 6.9929 75.8602 7.8761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60.5213 6.12119C60.5213 9.49443 57.7752 12.2405 54.4001 12.2405C51.0269 12.2405 48.2808 9.49443 48.2808 6.12119C48.2808 2.74609 51.0269 0 54.4001 0C57.7752 0 60.5213 2.74609 60.5213 6.12119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M61.0052 65.1291C61.0052 68.5042 58.2591 71.2503 54.8858 71.2503C51.5107 71.2503 48.7646 68.5042 48.7646 65.1291C48.7646 61.7559 51.5107 59.0098 54.8858 59.0098C58.2591 59.0098 61.0052 61.7559 61.0052 65.1291Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_186358",
    x1: 0,
    y1: 6,
    x2: 73,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShootPlayerRight);
export default __webpack_public_path__ + "static/media/shoot-player-right.7f0f96e9e11ebbe4f8cf451b5c02b308.svg";
export { ForwardRef as ReactComponent };